<button
  [id] = "buttonId"
  [type]="buttonType"
  class="btn min-height-btn {{buttonClass}}"
  [disabled]="isDisabled"
  [tooltipStyleClass]="tooltipStyleClass"
  [pTooltip]="tooltipText"
  [tooltipPosition]="tooltipPosition"
  (click)="onClick($event)">
  @if (icon) {
    <i [class]="icon"></i>
  }
  @if (imageSrc) {
    <img [src]="imageSrc" [alt]="imageAlt" [class]="imageClass" width="20"/>
  }

  <ng-content></ng-content>
</button>